import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Modal } from "../modal/Modal";
import { Button } from "../input/Button";
import { useForm } from "react-hook-form";
import styles from "./RoomEntryModal.scss";
import { Column } from "../layout/Column";
import { FormattedMessage, defineMessages, useIntl } from "react-intl";
import { TextInputField } from "../input/TextInputField";
import { AppLogo } from "../misc/AppLogo";
import { useCssBreakpoints } from "react-use-css-breakpoints";

// Good
const messages = defineMessages({
  placeholder: {
    id: "room-entry-modal.check-password-input-placeholder",
    defaultMessage: "Please enter your password"
  },
  error: {
    id: "room-entry-modal.check-password-input-error",
    defaultMessage: "The password is in correct."
  }
});

export function PassCheckModal({ onPassChecked, passRoom, roomName, customLogo, ...rest }) {
  const { isSubmitting, handleSubmit, register, setError, setValue, errors } = useForm();
  const breakpoint = useCssBreakpoints();
  const intl = useIntl();
  const onSubmit = useCallback(({ password }) => {
    if (password === passRoom) {
      onPassChecked();
    } else {
      setError("password", { type: "custom", message: intl.formatMessage(messages["error"]) });
      setValue("password", "");
    }
  }, []);
  return (
    <Modal className={classNames(styles.roomPassModal)} disableFullscreen {...rest} title={roomName}>
      <Column as="form" padding center onSubmit={handleSubmit(onSubmit)}>
        {breakpoint !== "sm" && breakpoint !== "md" && (
          <div className={styles.logoContainer}>{customLogo ? <AppLogo customLogo={customLogo} /> : <AppLogo />}</div>
        )}
        <TextInputField
          name="password"
          placeholder={intl.formatMessage(messages["placeholder"])}
          type="password"
          required
          ref={register}
          error={errors.password && errors.password.message}
        />
        <Button type="submit" preset="accept" disabled={isSubmitting}>
          <FormattedMessage id="room-entry-modal.check-password-button" defaultMessage="Submit" />
        </Button>
      </Column>
    </Modal>
  );
}

PassCheckModal.propTypes = {
  onPassChecked: PropTypes.func
};

PassCheckModal.defaultProps = {};
